exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3YILU6DQcy9_FzoKf8XVYT{width:100%;height:100%}", ""]);
// Exports
exports.locals = {
	"uiLessContainer": "_3YILU6DQcy9_FzoKf8XVYT"
};